// extracted by mini-css-extract-plugin
export default {"root":"TimeRange_root__HwImA","bookingInfo":"TimeRange_bookingInfo__5Bw7o","dateSection":"TimeRange_dateSection__Fhe-C"};